export default __webpack_public_path__ + "static/media/mysticalbane1.4590f561.png";